module.exports = __webpack_public_path__ + "static/media/31JFA6.e1c7c6aa.jpg";